import { withAsyncActionFeedback } from 'shared/ui/asyncAction';
import { FC } from 'react';

import { useModal } from 'shared/lib/modal';
import { Confirm } from 'shared/ui/confirm';
import { ButtonContained } from 'shared/ui/buttons/buttonContained';

import { useAppDispatch } from 'shared/lib/store';
import { resetBookingData, updateReset } from 'entities/orders';
import { ButtonOutlined } from 'shared/ui/buttons/buttonOutlined';


interface OrderDetailResetConfirmProps {
	onClose?: () => void;
}

export const OrderDetailResetConfirm: FC<OrderDetailResetConfirmProps> = ({
	onClose,
}) => {
  const ActionButtonTextWithFeedback = withAsyncActionFeedback(ButtonContained);

	const { openModal, closeModal } = useModal();
	const dispatch = useAppDispatch();


	const handleReset = async () => {
		localStorage.removeItem('booking');
		localStorage.removeItem('favoriteSavedTime');
		dispatch(updateReset(true));
		dispatch(resetBookingData());

		setTimeout(() => dispatch(updateReset(false)), 1000);
		onClose?.();
		closeModal();
	};

	const handleClick = async () => {
		onClose?.();
		closeModal();
	};

	return (
		<>
			<Confirm
				title={'Сбросить все заполненные данные формы?'}
				showCancelButton={false}
				confirmButton={
					<>
						<ActionButtonTextWithFeedback
							onClick={handleClick}
						>
							Нет, оставить
						</ActionButtonTextWithFeedback>
						<ButtonOutlined
							color="danger"
							isFullWidth
							onClick={handleReset}
						>
							Да, сбросить
						</ButtonOutlined>
					</>
				}

			/>
			<ButtonOutlined
				color="danger"
				isFullWidth={true}
				onClick={openModal}
			>
				Сбросить
			</ButtonOutlined>
		</>
	);
};
